import { Component, Output, OnInit } from '@angular/core';

import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { AuthService } from '@app/auth.service';
import { UserService } from '@app/user.service';

declare var $: any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  constructor(
    private Api: ApiService,
    private Auth: AuthService,
    private UserService: UserService,
    private Util: UtilService
  ) { }

  async ngOnInit() {
    
    await this.Auth.CheckSessionState();
    await this.GetProfile();
  }

  async GetProfile() {
    let Profile: any = await this.Auth.GetProfile(localStorage.getItem("AgentBank_Profile"));
    Profile = Profile[0];
    $('#txtName').val(Profile["dpa_name"]);
    $('#txtEmail').val(Profile["dpa_emailaddress"]);
    $('#txtPhoneNo').val(Profile["dpa_telephoneno"]);
    if (Profile["dpa_teamid"] != null) {
      let Team: any = {};
      Team = await this.Api.get("master", "agentBankTeam");
      if (Team["length"] != 0) {
        $('#txtTeam').val(Team.filter((a: {}) => a["dpa_agentbankteamid"] == Profile["dpa_teamid"])[0]["dpa_name"]);
      }
    }
    let Role: any = {}
    Role = await this.Auth.GetRole(Profile["dpa_roleid"]);
    if (Role[0]["dpa_access_changepassword"] == false) {
      $('#btnChangePwd').addClass("hidden");
    }
  }

  async ChangePassword() {
    if (!this.Auth.CheckSessionState())
      return;
    $('#txtCurrPwd').val('');
    $('#txtNewPwd').val('');
    $('#txtConfirmPwd').val('');
    $('#lblPwdError').html('');
    $('#dlgChngPwd').modal({
      backdrop: 'static',
      keyboard: false
    });
  }

  async SavePassword() {
    if (!this.Auth.CheckSessionState())
      return;

    let CurrPwd = $('#txtCurrPwd').val();
    let NewPwd = $('#txtNewPwd').val();
    let Profile: any = await(this.Auth.GetProfile(localStorage.getItem("AgentBank_Profile")));

    if (CurrPwd == "") {
      $('#lblPwdError').html('**กรุณาระบุรหัสผ่านปัจจุบัน');
      return;
    }
    // if (CurrPwd != Profile[0]["dpa_password"]) {
    //   $('#lblPwdError').html('**รหัสผ่านปัจจุบันไม่ถูกต้อง');
    //   return;
    // }
    if (NewPwd == "") {
      $('#lblPwdError').html('**กรุณาระบุรหัสผ่านใหม่');
      return;
    }
    if (NewPwd == CurrPwd) {
      $('#lblPwdError').html('**กรุณาระบุรหัสผ่านใหม่ให้ต่างจากรหัสผ่านปัจจุบัน');
      return;
    }
    if (!this.UserService.IsValidatePassword(NewPwd))
    {
      $('#lblPwdError').html('**รหัสผ่านใหม่ไม่ตรงตามข้อกำหนด');
      return;
    }
    if ($('#txtNewPwd').val() != $('#txtConfirmPwd').val()) {
      $('#lblPwdError').html('**กรุณายืนยันรหัสผ่านให้ตรงกัน');
      return;
    }

    // let UserName = Profile[0]["dpa_name"];
    let Res = await this.UserService.ChangePassword(localStorage.getItem("AgentBank_Profile"), CurrPwd, NewPwd);
    if (Res["RESMSG"] == "SUCCESS") {
      //let Profile = await this.Auth.GetProfile(UserName);
      //localStorage.setItem("AgentBank_Profile", JSON.stringify(Profile));
      this.Util.SuccessDialog("บันทึกสำเร็จ");
      setTimeout(() => {
        $('#btnCloseDlg').click();
      }, 500);
    }
    else {
      $('#lblPwdError').html('');
      this.Util.ErrorDialog("เปลี่ยนรหัสผ่านไม่สำเร็จ");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts